var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Modal_1 = require("./Modal");
var Button_1 = require("../react-component/Button");
var GreetingsText_1 = require("./GreetingsText");
var ProductDetails_1 = require("../utils/ProductDetails");
var ErrorDisplay = function (_a) {
    var handleReload = _a.handleReload, tollFree = _a.tollFree;
    return (React.createElement(Modal_1.default, { customClass: "error-display-modal" },
        React.createElement(GreetingsText_1.GreetingsText, { alignStyle: "center", text: "OH..No!" }),
        React.createElement("img", { src: "/static/img/car-product/oops-img.png" }),
        React.createElement("div", { className: "edm__title" }, "looks like something blew up!"),
        React.createElement("div", { className: "edm__para" },
            "Our Ninjas are looking into it. You can try again or call us on our toll free number ",
            tollFree,
            "."),
        React.createElement(Button_1.default, { title: "Try Again", onClick: handleReload, theme: "orange-gradient", customClass: "w--button--edp" })));
};
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleReload = function () { return window.location.reload(); };
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        this.setState({ hasError: true });
        window['Raven'] &&
            window['Raven'].captureException(error, {
                extra: info,
                type: 'error_popup',
                location: window.location.href,
            });
        window['dataLayer'] &&
            window['dataLayer'].push({
                event: 'GAEvent',
                category: 'Product Error Logs',
                actions: window.location.pathname,
                label: JSON.stringify(info),
            });
    };
    ErrorBoundary.prototype.render = function () {
        var tollFree = ProductDetails_1.getTollFree();
        return this.state.hasError ? (React.createElement(ErrorDisplay, { handleReload: this.handleReload, tollFree: tollFree })) : (this.props.children);
    };
    return ErrorBoundary;
}(React.Component));
exports.default = ErrorBoundary;
